import { useEffect, useState } from 'react'
import { useCatalogoApi } from '../catalogo/api'
import { useAuth } from '../auth/useAuth'
import { tieneRol } from '../auth/roles'
import { AsistenciaEntrenadoresTab } from '../asistencia/entrenadores/AsistenciaEntrenadoresTab'
import { t, Lang, categoriaLabel } from './i18n'

interface Equipo {
  id: string
  nombre: string
  categoria: string
}

// Issue #28/#37/#38: seguimiento de asistencia de entrenadores desde el Panel, en vez de mezclado
// dentro de la pestaña de cada equipo (donde el propio entrenador asignado podía verla/editarla).
// El coordinador edita; director y admin solo ven (acceso de solo lectura, impuesto también por el
// backend en `assertEntrenadoresWriteAccess`).
export function PanelEntrenadoresTab({ temporadaId, lang }: { temporadaId: string; lang: Lang }) {
  const api = useCatalogoApi()
  const { user } = useAuth()
  const esCoordinador = tieneRol(user, 'coordinador')
  const [equipos, setEquipos] = useState<Equipo[]>([])
  const [equipoId, setEquipoId] = useState('')

  useEffect(() => {
    if (!temporadaId) return
    api.get(`/catalogo/temporadas/${temporadaId}/equipos`).then((data: Equipo[]) => {
      setEquipos(data)
      setEquipoId((current) => (data.some((e) => e.id === current) ? current : (data[0]?.id ?? '')))
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [temporadaId])

  if (equipos.length === 0) {
    return <p>{t('sinEquiposEntrenadores', lang)}</p>
  }

  return (
    <div>
      <select value={equipoId} onChange={(e) => setEquipoId(e.target.value)}>
        {equipos.map((equipo) => (
          <option key={equipo.id} value={equipo.id}>
            {equipo.nombre} ({categoriaLabel(equipo.categoria, lang)})
          </option>
        ))}
      </select>

      {equipoId && (
        <AsistenciaEntrenadoresTab key={equipoId} equipoId={equipoId} lang={lang} readOnly={!esCoordinador} />
      )}
    </div>
  )
}
